import { Hint } from "@/components/ui/hint";
import { cn } from "@/lib/utils";
import { TriangleAlert } from "lucide-react";
import { useTranslation } from "react-i18next";

interface ShiftReportEntryWarningProps {
  present: number | null;
  ordered: number | null;
  className?: string;
}

const ShiftReportEntryWarning = ({
  present,
  ordered,
  className,
}: ShiftReportEntryWarningProps) => {
  const { t } = useTranslation();

  if (present == null || ordered == null) {
    return null;
  }

  const diff = present - ordered;

  if (diff < 0) {
    return (
      <Hint
        icon={TriangleAlert}
        className={cn("truncate whitespace-nowrap", className)}
        classNameText="truncate"
      >
        {t("shiftReports.entry.warning")}
      </Hint>
    );
  }
  return null;
};

export default ShiftReportEntryWarning;
